import React from 'react';
import Video from '../renderer/Video';
import Audio from '../renderer/Audio';
import Image from '../renderer/Image';
import { Typography } from '@mui/material';

const components = {
    'fib': FillInTheBlanksAnswers,
}

export default function RightAnswer({ answerLabels, choices, type }) {
    if (!Array.isArray(answerLabels)) {
        answerLabels = [answerLabels];
    }

    const Component = components[String(type).toLowerCase()];
    const props = { answerLabels, choices };

    return (
        <p style={styles.container}>
            <span style={{ fontSize: '16px' }}>{`Correct ${answerLabels.length < 2 ? 'Answer' : 'Answers'}: `}</span>

            {Component ? <Component {...props} /> : <Default {...props} />}

        </p>
    )
}

function FillInTheBlanksAnswers({ answerLabels }) {
    return (
        <React.Fragment>
            {answerLabels.map((item, index) => {
                return (
                    <span key={index} style={styles.highlightFib}>
                        &nbsp;{item}{index === answerLabels.length - 1 ? '.' : ','}
                    </span>
                )
            })}
        </React.Fragment>
    )
}

function Default({ answerLabels, choices, }) {

    const renderMedia = (choice) => {
        const { contentURL, style } = choice?.value || {};
        if (!contentURL) return null;

        const mediaProps = { contentUrl: contentURL, renderDefault: true };

        if (style === 'text-and-image') {
            return <Image {...mediaProps} />;
        }
        if (style === 'text-and-video') {
            return <Video {...mediaProps} />;
        }
        if (style === 'text-and-audio') {
            return <Audio {...mediaProps} />;
        }
        return null;
    };

    const getFilename = (url) => {
        // Check if it's a YouTube URL
        if (url.includes('youtube.com') || url.includes('youtu.be')) {
            return 'YouTube Video';
        }

        // Check for UUID pattern
        const match = url.match(/[a-f0-9-]{36}_(.+)$/);
        return match ? match[1] : url.split('/').pop();
    };

    return (
        <React.Fragment>
            {answerLabels && answerLabels.length ? answerLabels.map((item, index) => {
                const choice = (choices || []).find(e => e.label == item) || {};
                return (
                    <div key={index} style={{ display: 'flex', alignItems: 'center', margin: '10px', gap: '5px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', }}>
                            <Typography key={index} style={styles.highlight}>
                                {`${choice?.label}. ${choice?.value?.text && choice.value.text}`}
                            </Typography>
                            {renderMedia(choice)}

                        </div>
                        <span>{`${index !== answerLabels.length - 1 ? ', ' : ''}`}</span>
                    </div>
                )
            }) : ''}
        </React.Fragment>
    )
}

const styles = {
    container: {
        fontSize: '18px',
        fontWeight: 400,
        display: 'flex',
        alignItems: 'center',
        color: 'darkgrey',
        marginTop: '15px',
        lineHeight: 1.2,
        color: 'rgba(105, 69, 169, 1)',
    },
    highlight: {
        color: 'rgba(105, 69, 169, 1)',
        fontWeight: 600,
        display: 'flex',
        width: '100%',
    },
    highlightFib: {
        color: 'rgba(105, 69, 169, 1)',
        fontWeight: 600,
        display: 'flex',
        // width: '100%',
    }
};